export const DEFAULT_FREE_COLOR = "#60bc60";
export const DEFAULT_BOOKED_COLOR = "#e91919";
